<template>
    <b-card>
        <!-- Form -->
        <b-form
          class="p-2"
        >
        <b-row>
          <b-col md="12">
                    <label for="sejarah_hubungan_bilateral"><h4>Sejarah Hubungan Bilateral</h4></label>
                    <editor />
              </b-col>
        </b-row>
         
      
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              @click="updateData"
            >
              Simpan
            </b-button>
          </div>
  
        </b-form>
    </b-card>
  </template>
  
  <script>
  import {
    BCard, BButton, BAvatar, BRow, BCol, BBadge,
    BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BFormFile, BMedia, BMediaBody, BMediaAside, BLink, BCardText, BImg,
    BFormSpinbutton, BFormTextarea,
  } from 'bootstrap-vue'
  import vSelect from 'vue-select'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { ref } from '@vue/composition-api'
  import store from '@/store'
  import Ripple from 'vue-ripple-directive'
  import { required, alphaNum, email } from '@validations'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import formValidation from '@core/comp-functions/forms/form-validation'
  import { avatarText } from '@core/utils/filter'
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import '@core/scss/vue/libs/vue-flatpicker.scss'
  // Impor komponen Quill Editor
  import { quillEditor } from 'vue-quill-editor';
  import Editor from './Editor.vue';
  // Impor file CSS yang diperlukan
  // import 'vue-quill-editor/dist/vue-quill.snow.css'; // Ganti dengan tema yang sesuai jika diperlukan
  
  
  export default {
    components: {
      BCard,
      BButton,
      BRow,
      BCol,
      BForm,
      BFormGroup,
      BFormInput,
      BFormTextarea,
      BFormFile,
      BMedia,
      BMediaBody,
      BMediaAside,
      BLink,
      BCardText,
      BImg,
      vSelect,
      quillEditor,
      Editor,
    },
    directives: {
      Ripple,
    },
    data() {
      return {
        rowData: {},
        error: {},
        required,
        alphaNum,
        email,
        configs: {
          basic: {},
          wrap: {
            wrap: true,
            altFormat: 'M j, Y',
            altInput: true,
            dateFormat: 'Y-m-d',
          },
        },
      }
    },
    methods: {
      getSejarahHubunganBilateral(){
        getSejarahHubunganBilateralById(this.$route.params.uuid)
        .then(response => {
            if(response.data.success == true)
            {
              this.rowData = response.data.data
             
            }
        })
        .catch(error => {
          // console.log(error)
        })
      },
      onFileChangeBendera(event) {
          const file = event.target.files[0]; // Get the selected file
          if (file) {
            const reader = new FileReader();
  
            // Set up the FileReader's onload event, which will be triggered when the reading is done
            reader.onload = () => {
              this.rowData.bendera = reader.result; // Set the Base64 string to the imagePreview data property
            };
  
            // Read the file as a data URL (Base64)
            reader.readAsDataURL(file);
          }
      },
      onFileChangePeta(event) {
          const file = event.target.files[0]; // Get the selected file
          if (file) {
            const reader = new FileReader();
  
            // Set up the FileReader's onload event, which will be triggered when the reading is done
            reader.onload = () => {
              this.rowData.peta = reader.result; // Set the Base64 string to the imagePreview data property
            };
  
            // Read the file as a data URL (Base64)
            reader.readAsDataURL(file);
          }
      },
      async updateData() {
        updateSejarahHubunganBilateral(this.rowData)
          .then(response => {
            if(response.data.success == true)
            {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'SejarahHubunganBilateral',
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: response.data.message,
                },
              })
              this.getSejarahHubunganBilateral()
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'SejarahHubunganBilateral',
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: response.data.message,
                },
              }) 
            }
          })
          .catch(error => {
            // console.log(error)
          })
      },
      formatPrice(value) {
        const val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      formatDate(value, format) {
        return moment(String(value)).format(format)
      },
      makeToast(variant = null, message = null) {
        this.$bvToast.toast(message, {
          // title: `Variant ${variant || 'default'}`,
          title: 'Instansi',
          variant,
          solid: true,
          autoHideDelay: 3000,
        })
      },
    },
  }
  </script>
  
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/quill.scss';
  @import '@core/scss/vue/pages/page-blog.scss';
  </style>
